import Anchor from 'containers/ac-containers/ac-anchor';
import { useModalContext } from 'hooks/useModalContext';
import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { SafeguardSection } from '../home/components';
import { ClassesSection, GradesSection, OnlineSection, PlatformSection, SubjectSection, TutorsSection, WorksSection } from './components';
import styles from './styles.scss';
import { keyCountMap, appointmentSource } from '@services/test-form';
import { useSelector } from 'react-redux';
import { ConnectState } from 'states/connect';
import { setOpen1on1Form, getOpen1on1, setOpen1on1 } from '@utils/testForm';


export default function OneOnOnePage() {
	const { setTrigger, setEvent, setVisibleEnTestFormModal, setEnTestFormModalData } = useModalContext();
	const anchor = useHistory().location.hash;
	const local = useSelector((state: ConnectState) => state.app.local);
	const timeVal = useRef(0);

	const getCount = async () => {
		setTrigger(true);
		// // 英文状态下 5-5概率展示A/B弹窗
		// if (local === 'en') {
		// 	keyCountMap({}).then((res: any) => {
		// 		setOpen1on1Form();
		// 		if (res.code === '0') {
		// 			if (!res.data.B || Number(res.data.A) > Number(res.data.B)) {
		// 				setVisibleEnTestFormModal(true);
		// 				setEnTestFormModalData({ sourceKey: 'B' });
		// 			} else {
		// 				setTrigger(true);
		// 				setEnTestFormModalData({ sourceKey: 'A' });
		// 			}
		// 		} else {
		// 			setTrigger(true);
		// 		}
		// 	});
		// } else {
		// 	setTrigger(true);
		// }
	};

	//测试弹窗--接口埋点 pv
	useEffect(() => {
		const time = getOpen1on1();
		appointmentSource({ eventType: 1, landingPageId: 2, duration: time ? new Date().getTime() - Number(time) : undefined });
		setOpen1on1();
	}, []);

	//接口埋点 uv
	useEffect(() => {
		timeVal.current = new Date().getTime();
		return () => {
			if (timeVal.current) {
				appointmentSource({ eventType: 1, landingPageId: 2, duration: new Date().getTime() - timeVal.current });
			}
		};
	}, []);

	return (
		<div className={styles['ac-container']}>
			<main className={styles['ac-1on1']}>
				<OnlineSection
					onClick={() => {
						getCount();
						setEvent({ eventId: 'ACW_1on1_getlesson' });
					}}
				/>
				<ClassesSection />
				<PlatformSection />
				<TutorsSection />
				<SubjectSection />
				<WorksSection />
				<GradesSection />
				<SafeguardSection />
				<Anchor className={styles.anchor} anchorText={'online'} eventId="PAG_94b2e816f60188a4">
					<img src="https://web-data.zmlearn.com/image/jeHUMoWZJJibHRhSFNC1C1/img_backtop%402x.png" alt="" />
				</Anchor>
			</main>
		</div>
	);
}
